/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Preview_Photos_Media_LinkInputs */

const cs_portals_preview_photos_media_link = /** @type {(inputs: Portals_Preview_Photos_Media_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spravovat ve Fotkách a médiích`)
};

const en_portals_preview_photos_media_link = /** @type {(inputs: Portals_Preview_Photos_Media_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage on Photos & Media`)
};

/**
* | output |
* | --- |
* | "Manage on Photos & Media" |
*
* @param {Portals_Preview_Photos_Media_LinkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_preview_photos_media_link = /** @type {((inputs?: Portals_Preview_Photos_Media_LinkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Preview_Photos_Media_LinkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_preview_photos_media_link(inputs)
	return cs_portals_preview_photos_media_link(inputs)
});